export default {"src":"/_next/static/media/templates_icon.39fee42c.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};